import styles from "./SignUpModal.module.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import { path } from "../common/Common";
import { AccountManager } from "../../workers/AccountManager";
import { ELoginType } from "../../workers/ELoginType";
import { useNavigate } from "react-router-dom";

import { useModal } from "../modal/Modal";
import ModalButtons from "../modal/ModalButtons";

/**
 * @author kmy
 * @date 2025-03-17
 * @remark 회원가입 방법 선택 모달
 */

interface SignUpModalProps {
    onClose: () => void;
}


const SignUpModal: React.FC<SignUpModalProps> = ({ onClose }) => {

    const { ModalComponent, openModal, closeModal } = useModal();

    const navigate = useNavigate();

    const portalLogInUser = async (type: ELoginType) => {
        const accountManager = AccountManager.getInstance();
        const result = await accountManager.login(type);

        if (!result || !result.flag) {
            openModal({
                title: "안내",
                children: <p>{(result as any).message ?? "로그인 중 오류가 발생했습니다."}</p>,
                modalButtons: <ModalButtons
                    buttonCount={1}
                    buttons={[
                        {
                            label: "확인",
                            color: "Primary",
                            onClick: () => {
                                closeModal();
                            },
                        },
                    ]}
                />
            });
            return;
        }
    }

    return (
        <>
            <ModalComponent />
            <div className={`${styles.login_container}`}>
                {/* 소셜 회원가입, 일반 회원가입 버튼 */}
                <div className={`${styles.social_button_container}`}>
                    <button className={`${styles.social_button} ${styles.google}`} onClick={() => portalLogInUser(ELoginType.GOOGLE)}>구글 아이디로 시작하기</button>
                    <button className={`${styles.social_button} ${styles.naver}`} onClick={() => portalLogInUser(ELoginType.NAVER)}>네이버 아이디로 시작하기</button>
                    <button className={`${styles.social_button} ${styles.kakao}`} onClick={() => portalLogInUser(ELoginType.KAKAO)}>카카오 아이디로 시작하기</button>
                    <button className={`${styles.social_button} ${styles.facebook}`} onClick={() => portalLogInUser(ELoginType.FACEBOOK)}>페이스북 아이디로 시작하기</button>
                    <button className={`${styles.social_button} ${styles.google}`}>
                        <Link className={`${styles.login_options_link}`} to={path.SIGNUP} style={{ margin: '0' }} onClick={onClose}>다른 방법으로 회원가입</Link>
                    </button>
                </div>
            </div>
        </>
    );
}

export default SignUpModal;
